module.exports = __webpack_public_path__ + "assets/46e3be65457fbb3300075a46c376949c2.jpg";